import React, { useState, useCallback, memo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
//import { gtag_CurationList, gtag_CurationListClick, gaEvent } from 'libs/gtag'
import Item from './item'
import {  ga4AdView,  ga4AdClick } from 'estimate_list/libs/googleTagmanager'
// import {itemAPI} from "../api/common";
import {Loading} from "../../common/loadingComponent";

const ListCuration = ({ curation }) => {
    /* pc, shopping (큐레이션 견적비교 카테고리) */
    const { domain } = useSelector(state => state.initial)
    const [active, setActive] = useState(false)
    const [moreCurationList, setmoreCurationList] = useState(false)
    const maxAdvListLength = 3

    const ad = {
        id: curation.mall_name + '_' + curation.idx_b_manager,
        name: curation.nm_ad,
        creative: curation.ad_id,
        cate_id: curation.cat_id,
    }
    // 광고 tag, SVP003, SVP004
    // useEffect(() => {
    // uaAdView(curation)
    // if (curation?.items.length > 0) {
    //     uaAdView(ad)
    // const lists = curation.items.map((v, i) => ({ ...v, num:i+1}))
    // gtag_CurationList({ lists: lists, ad })
    // gaEvent({
    //     type: 'view',
    //     event_category: `${ad.code_ad}_${ad.nm_ad}`,
    //     event_label: ad.pr_idx,
    //     value: 1,
    //     category: `${curation.cat_id}_${curation.cate_name}`,
    //     idx_b_manager: ad.idx_b_manager
    // })
    // }
    // }, [curation]) // eslint-disable-line

    const onMouseImg = useCallback(() => {
        if (!active) {
            setActive(true)
        }
    }, [active])

    useEffect(() => {
        if (domain === 'shopping' || domain === 'pc') {
            // 광고 노출 태그
            ga4AdView(curation)
            // uaAdView(curation)

            // if(curation.items.length > 0){
            // console.log(curation.items)
            // ga4_viewItemList({ lists:curation.items, list_name:domain+'.list' })
            // ua_viewItemList({ lists:curation.items, list_name:domain+'.list' })
            // }
        }
    }, [curation, domain])

    const advListItemClick = (item, adinfo) => {
        if (domain === 'shopping' || domain === 'pc') {
            // 광고 클릭 태그
            ga4AdClick({ item, adinfo: adinfo })
            // uaAdClick({ item, adinfo: adinfo })
        }
    }

    // const curationListItemClick = (item) => {
    //     if(process.env.REACT_APP_TLD === 'kr'){
    //         const list_position = curation.items.findIndex(v => v.item_id === item.item_id) + 1
    //         gtag_CurationListClick({ item, ad, list_position })
    //     }
    // }

    return (
        <Style>
            <div className="adv_top_message border_style">
                마케팅플랫폼 <a href='null'>영상제작문의</a>
            </div>
            <div className="marketing_platform_content">
                {curation?.images?.exp?<img
                    src={active? curation?.images?.exp : curation?.images?.default}
                    alt={curation.nm_curation}
                    onMouseEnter={onMouseImg}
                />:<Loading />}

                {active && (
                    <iframe
                        title={curation.nm_curation}
                        width={domain === 'shopping' ? '950' : '890'}
                        height={domain === 'shopping' ? '534' : '500'}
                        src={curation.youtube}
                        allow="picture-in-picture"
                    />
                )}
            </div>
            <div className="item_wrap">
                {curation?.items?.slice(0, moreCurationList ? curation.items.length : maxAdvListLength).map(v => {
                    return <Item key={v.item_id} data={v} fixMode='list' gaEvent={advListItemClick} adInfo={ad} />
                })}
                {curation?.items?.length > maxAdvListLength && (
                    <More type="button" className="button" arrow={moreCurationList ? 'up' : 'down'} onClick={() => setmoreCurationList(v => !v)}>
                        <i className="icon-angle-down" />
                    </More>
                )}
            </div>
        </Style>
    )
}

const Style = styled.div`
    .marketing_platform_content {
        overflow: hidden
    }
`
const More = styled.button`
    &.button {
        position: absolute;
        bottom: 0;
        right: 0;
        font-size: 19px;
        width: 25px;
        height: 25px;
        color: #fff;
        background: #999;
        vertical-align: middle;
        cursor: pointer;
        &:hover {
            background: #418ded;
        }
        i {
            transform: rotate(${props => props.arrow === 'up' ? 180 : 0}deg);
            display: block;
        }
    }
`

export default memo(ListCuration)



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/list_curation.js